"use client";

import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export interface AddCustomerPaymentMethodCardProps {
  label: string;
  onClick: () => void;
}

export function AddCustomerPaymentMethodCard({
  label,
  onClick,
}: AddCustomerPaymentMethodCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "w-[300px] min-h-[88px] rounded-xl border border-dashed border-border",
        "flex flex-row items-center gap-3 px-4 py-4",
        "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
        "transition-colors cursor-pointer"
      )}
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-dashed border-current">
        <Plus className="h-4 w-4" />
      </div>
      <span className="text-sm font-medium">{label}</span>
    </button>
  );
}
